<div id="st-sub-licenses-stcommonhighpadding" class="st_common_high_padding mt-2" [class.t1-page]="isTemplate1" *ngIf="isBaseRoute()">

    <div id="st-sub-licenses-block" class="d-flex justify-content-between align-items-center gap-3">
        <div id="st-sub-licenses-role-tab-container" class="role-tab-container d-flex align-items-center gap-2" *ngIf="screenWidth > 600 || !searchBarExpanded">
            <button type="button" (click)="select_role(role)" (keydown.enter)="select_role(role)" (keydown.space)="$event.preventDefault(); select_role(role)" *ngFor="let role of role_list; trackBy: trackById" class="role-tab d-flex align-items-center justify-content-start" [ngClass]="{'active': role.role_id === selected_role?.role_id}">
                <p class="fs-16 text-center">{{ role.role_name | translate }}</p>
            </button>
        </div>
        
        
        <div id="st-sub-licenses-block-1" [ngClass]="screenWidth > 600 ? 'search-container' : 'w-100'">
            <stupa-common-search-bar [searchPlaceholder]="'search'|translate" class="search-player-input flex-1"
                [searchQuery]="searchQuery" (searchChange)="onSearchChange($event)"
                (inputExpandedChange)="onSearchBarInputExpanded($event)"></stupa-common-search-bar>
        </div>
    </div>

    <div id="st-sub-licenses-aligible-licensees-container" class="aligible-licensees-container mt-3">
        <div id="st-sub-licenses-sublicenses-container" class="sublicenses-container">
            <div id="st-sub-licenses-block-2" class="d-flex gap-2 w-100 flex-wrap">
                @if (listLoading.loading() && !sublicenses?.values?.length) {
                <stupa-skeleton-loader variant="cards" />
                }
                <div [id]="'st-sub-licenses-aligible-license-block' + (i)" class="aligible-license-block" *ngFor="let sublicense of sublicenses?.values; let i = index; trackBy: trackById"
                    (click)="navigateToSubLicenseManagement(sublicense)" (keydown.enter)="navigateToSubLicenseManagement(sublicense)" (keydown.space)="$event.preventDefault(); navigateToSubLicenseManagement(sublicense)">
                    <div [id]="'st-sub-licenses-block-3' + i" class="d-flex align-items-center justify-content-between gap-2 w-100">
                        <div [id]="'st-sub-licenses-block-4' + i" class="d-flex align-items-start gap-2">
                            <div [id]="'st-sub-licenses-club-logo-container' + i"
                                class="club-logo-container club-logo-config d-flex align-items-center justify-content-center">
                                <ng-container
                                    *ngIf="is_image(setHeaderValue('Profile Logo',sublicense)); else templateA">
                                    <img [src]="setHeaderValue('Profile Logo',sublicense)" alt="Logo">
                                </ng-container>
                                <ng-template #templateA>
                                    <h1 class="fw-bold">{{getAbbrivation(setHeaderValue('Full Name',sublicense))}}</h1>
                                </ng-template>
                                
                            </div>
                            <div [id]="'st-sub-licenses-club-details-container' + i" class="club-details-container d-flex flex-column justify-content-start w-100">
                                <p class="fs-12 fw-medium club_display_name">{{setHeaderValue('Full Name',sublicense)}}
                                </p>
                                <p class="fs-10 fw-medium sublicense-management-secondary-text">
                                    {{setHeaderValue('Profile Display Name',sublicense)}}</p>
                                
                                <div id="st-sub-licenses-column-group-2" class="d-flex align-items-center column-gap-2 flex-wrap">
                                    <a tabindex="0" class="sub-license-link fs-12 fw-medium st-primary-lt"
                                        [href]="setHeaderValue('Profile Hyperlinks',sublicense)[0]?.link"
                                        (click)="onLinkClick($event)" (keydown.enter)="onLinkClick($event)">{{
                                        setHeaderValue('Profile Hyperlinks',sublicense)[0]?.link_name}}</a>
                                    <div id="st-sub-licenses-detail-divider" class="detail-divider"
                                        *ngIf="setHeaderValue('Profile Hyperlinks',sublicense)[0]?.link && setHeaderValue('Profile Hyperlinks',sublicense)[1]?.link">
                                    </div>
                                    <a tabindex="0" class="sub-license-link fs-12 fw-medium st-primary-lt"
                                        [href]="setHeaderValue('Profile Hyperlinks',sublicense)[1]?.link"
                                        (click)="onLinkClick($event)" (keydown.enter)="onLinkClick($event)">{{
                                        setHeaderValue('Profile Hyperlinks',sublicense)[1]?.link_name}}</a>
                                </div>
                                <div id="st-sub-licenses-column-group-2-7" class="d-flex align-items-center column-gap-2 flex-wrap">
                                    <p class="fs-12 fw-medium st-primary-accent-2">{{
                                        setHeaderValue('Profile Email',sublicense)}}</p>
                                    <div id="st-sub-licenses-detail-divider-8" class="detail-divider"
                                        *ngIf="setHeaderValue('Profile Email',sublicense) && setHeaderValue('Profile Phone',sublicense)">
                                    </div>
                                    <p class="fs-12 fw-medium st-primary-accent-2">
                                        {{ setHeaderValue('Profile Country Code',sublicense) + " " +
                                        setHeaderValue('Profile Phone',sublicense)}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="st-sub-licenses-sublicene-no-data" class="sublicene-no-data d-flex align-items-center justify-content-center w-100"
                    *ngIf="sublicenses?.values.length == 0 && !listLoading.loading()">
                    <stupa-no-data-found class="h-100"></stupa-no-data-found>
                </div>
            </div>
        </div>
        <div id="st-sub-licenses-stpaginator" class="st_paginator sticky_paginator" *ngIf="subLicensesCount > 10">
            <div id="st-sub-licenses-pagination" class="d-flex justify-content-between align-items-center pagination">
                <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="per_page"
                    [totalRecords]="subLicensesCount" />
                <div id="st-sub-licenses-entry-count" class="entry-count d-flex align-items-center gap-1">
                    <span>{{ first + 1 }}-</span>
                    <p-dropdown [options]="[10, 20, 30, 40, 50, 100]" [(ngModel)]="per_page"
                        (onChange)="onPageSizeChange()" styleClass="inline-page-size-dropdown">
                    </p-dropdown>
                    <span>{{'of'|translate}} {{ subLicensesCount }}</span>
                </div>
            </div>
            
        </div>
    </div>
</div>

<router-outlet></router-outlet>


